import request from "@/router/request";

export const getUserInfo = () => {
    return request({
        url: '/api/customer/get',
        method: "get",
    });
}
export const getOrders = () => {
    return request({
        url: '/api/customer/Orders',
        method: "get"
    });
}
export const orderDetail = (billNo) => {
    return request({
        url: '/api/customer/OrderDetail',
        method: "get",
        params: {
            billNo
        }
    });
}
export const getWaterRecharge = (index, size) => {
    return request({
        url: '/api/customer/WaterRecharge',
        method: "get",
        params: {
            index,
            size
        }
    });
}

export const getWaterRecord = (index, size) => {
    return request({
        url: '/api/customer/WaterRecord',
        method: "get",
        params: {
            index,
            size
        }
    });
}
//绑定就诊卡
export const bindWater = (data) => {
    return request({
        url: '/api/Customer/BindWaterFeeInfo',
        method: "post",
        data: data
    });
}
//绑定就诊卡
export const BindMedicalCard = (data) => {
    return request({
        url: '/api/Customer/BindMedicalCard',
        method: "post",
        data: data
    });
}

//获取通知公告
export const GetNoticeInfo = () => {
    return request({
        url: '/api/NoticeInfo/GetNoticeInfo',
        method: "get",
        meta: {
            isToken: false
        }
    });
}